<nb-card status="danger" size="large">
  <nb-card-header>Trading</nb-card-header>
  <nb-card-body></nb-card-body>
  <nb-card-footer></nb-card-footer>
</nb-card>
